import { z } from "zod";
export const claim = z.object({
  email: z
    .string({ required_error: "Email is required" })
    .trim()
    .email({ message: "It's not a valid e-mail address" }),
});
